module.exports = __webpack_public_path__ + "img/minimize_focused_prelight.8b10d796.png";